export const PREPR_CUSTOMER_COOKIE_NAME = "__prepr_uid";
